import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(

    /*<Router basename={process.env.REACT_APP_ROUTER_BASE || ''}>
        <div>
            <Route path = {"/unauth"} render = {(props) => (<NotAuthenticated {...props}/>)}/>
            <Route path ={"/auth"} render = {(props) => (<Authenticate {...props}/>)}/>
            <Route path={"/sps2info"} render = {(props) => (<App {...props}/>)}/>
            <Route path={"/sps"} render={(props) => (<App {...props}/>)}/>
        </div>
    </Router>,*/
    <React.StrictMode>
        <App/>
    </React.StrictMode>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

/*
<Router basename={process.env.REACT_APP_ROUTER_BASE || ''}>
        <div>
            <Route path = {"/unauth"} render = {(props) => (<NotAuthenticated {...props}/>)}/>
            <Route path ={"/auth"} render = {(props) => (<Authenticate {...props}/>)}/>
            <Route path={"/sps2info"} render = {(props) => (<App {...props}/>)}/>
            <Route path={"/sps"} render={(props) => (<App {...props}/>)}/>
        </div>
    </Router>,
 */